import { useQuery } from '@tanstack/react-query';
import { SESSION_FEEDBACK_QUERY_KEY } from '../../contracts';
import { getFeedbackV2 } from '../api/feedback';
import { getSessionDataConfig } from '../config';

export function useQuerySessionFeedback(sessionId: string) {
  return useQuery({
    enabled: !!sessionId,
    refetchOnMount: 'always',
    queryKey: [SESSION_FEEDBACK_QUERY_KEY, sessionId],
    queryFn: async () => {
      return (await getFeedbackV2(sessionId)).data;
    },
  });
}

export function invalidateSessionFeedback(sessionId: string) {
  return getSessionDataConfig()
    .getQueryClient()
    .invalidateQueries({
      queryKey: [SESSION_FEEDBACK_QUERY_KEY, sessionId],
    });
}
